import * as yup from "yup";

export const menuFilterSchema = yup
  .object()
  .shape({
    filters: yup.array().of(
      yup
        .object()
        .shape({
          value: yup.string().required(),
          selected: yup.boolean().required(),
        })
        .required(),
    ),
  })
  .required();
